import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Shipments from './pages/Shipments';
import ShipmentDetail from './pages/ShipmentDetail';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import NewCustomer from './pages/NewCustomer';
import EditCustomer from './pages/EditCustomer';
import NewShipment from './pages/NewShipment';
import Users from './pages/Users';
import Profile from './pages/Profile';
import LoadingSpinner from './components/LoadingSpinner';
import EditShipment from './pages/EditShipment';
import Reports from './pages/Reports';
import Cities from './pages/Cities';
import RoutesPage from './pages/Routes';
import ShipmentBatches from './pages/ShipmentBatches';

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Routes>
      <Route 
        path="/login" 
        element={user ? <Navigate to="/dashboard" replace /> : <Login />} 
      />
      <Route 
        path="/*" 
        element={
          user ? (
            <SocketProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/shipments" element={<Shipments />} />
                  <Route path="/shipments/new" element={<NewShipment />} />
                  <Route path="/shipments/:id" element={<ShipmentDetail />} />
                  <Route path="/shipments/:id/edit" element={<EditShipment />} />
                  <Route path="/customers" element={<Customers />} />
                  <Route path="/customers/new" element={<NewCustomer />} />
                  <Route path="/customers/:id" element={<CustomerDetail />} />
                  <Route path="/customers/:id/edit" element={<EditCustomer />} />
                  <Route path="/users" element={
                    <ProtectedRoute requiredRoles={['management', 'system_administrator']}>
                      <Users />
                    </ProtectedRoute>
                  } />
                  <Route path="/cities" element={
                    <ProtectedRoute requiredRoles={['management', 'system_administrator']}>
                      <Cities />
                    </ProtectedRoute>
                  } />
                  <Route path="/routes" element={
                    <ProtectedRoute requiredRoles={['management', 'system_administrator']}>
                      <RoutesPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/shipment-batches" element={
                    <ProtectedRoute requiredRoles={['management', 'system_administrator', 'shipment_agent']}>
                      <ShipmentBatches />
                    </ProtectedRoute>
                  } />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            </SocketProvider>
          ) : (
            <Navigate to="/login" replace />
          )
        } 
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App; 